// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FireFilledSvg from "@ant-design/icons-svg/es/asn/FireFilled";
import AntdIcon from '../components/AntdIcon';

var FireFilled = function FireFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FireFilledSvg
  }));
};

FireFilled.displayName = 'FireFilled';
export default React.forwardRef(FireFilled);